import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { HttpService } from "../../service/HTTPService/HttpService";
import { environment } from "../../../environments/environment";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import { Globals } from "../../globals";
import { DatePipe } from "@angular/common";
import * as moment from "moment";
import "chartjs-plugin-zoom";
import { ApiService } from "../../service/apiUrls/apiUrl.service";
@Component({
  selector: "app-actions-cell",
  template: `{{ params.value }}
    <ng-template #popTitle>
      Power Source Chart

      <span
        class="modal-title"
        style="margin-left: 3%;font-size: 14px;margin-top: 0.5%;"
        id="modal-basic-title"
        >Last Updated : {{ lastUpdted }}</span
      >
      <button
        id="viewFull"
        class="btn btn-light btn-sm "
        style="float:right; padding-top: 0px;padding-bottom:0px;margin:0px;"
        (click)="viewFullScreen(content)"
      >
        <img src="assets/img/icons/maximize.png" />
      </button>
    </ng-template>
    <ng-template #popContent>
      <div class="card-body pb-0">
        <canvas
          id="lineCharts"
          baseChart
          class="chart"
          [datasets]="lineChartData"
          [labels]="lineChartLabels"
          [options]="lineChartOptions"
          [colors]="lineChartColors"
          [legend]="lineChartLegend"
          [chartType]="lineChartType"
        ></canvas>
      </div>
    </ng-template>
    <div id="powersourceChart" style="float:right;">
      <button
        id="addOns"
        type="button"
        class="btn"
        placement="bottom"
        #popover="ngbPopover"
        [ngbPopover]="popContent"
        [popoverTitle]="popTitle"
        container="body"
        (click)="generateChart()"
      >
        ...
      </button>
    </div>

    <div id="modalPopUp">
      <ng-template #content let-modal>
        <div class="modal-header" id="modalPopUp1" style="padding: 7px;">
          <h4 class="modal-title" id="modal-basic-title">Power Source Chart</h4>
          <span
            class="modal-title"
            style="margin-left: 41%;font-size: 14px;margin-top: 0.5%;"
            id="modal-basic-title"
            >Last Updated : {{ lastUpdted }}</span
          >
          <button
            type="button"
            class="btn btn-light btn-sm close"
            style="padding:8px;padding-top:0px !important;margin-top: 0px;margin-right: 0px;"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
          >
            <img src="assets/img/icons/minimize.png" />
          </button>
        </div>
        <div class="modal-body" id="modalPopUp2">
          <form>
            <canvas
              id="lineCharts"
              baseChart
              class="chart"
              [datasets]="lineChartData"
              [labels]="lineChartLabels"
              [options]="lineChartOptions"
              [colors]="lineChartColors"
              [legend]="lineChartLegend"
              [chartType]="lineChartType"
            ></canvas>
          </form>
        </div>
      </ng-template>
    </div> `,
  styles: [],
})
export class AdditionalDetailsRendererComponent
  implements ICellRendererAngularComp
{
  public selectedCity;
  public params: any;
  closeResult: string;
  public sid = "";
  powerSourceArray: any[] = [];
  searchPowersource: any[];
  chartDetail: any[] = [];
  lineChartData: any[] = [];
  public lineChartLabels: any[] = [];
  public powerSources: any[] = [];
  public componentName = "";
  public fullScrMode = false;
  allSensorType = "line";
  public lineChartLegend = false;
  public lineChartType = this.allSensorType;
  public lastUpdted = "";
  public lUpdatedEpoch = "";
  cities = [
    { id: "line", name: "Line" },
    { id: "bar", name: "Bar" },
    { id: "pie", name: "Pie" },
  ];

  datetimeformat;
  agInit(params: any): void {
    this.params = params;
    this.sid = this.params.data.SiteID;
    this.lastUpdted = this.params.data.lUpdated;
    var date = new Date(this.lastUpdted);
    this.lastUpdted = this.datePipe.transform(date, "dd-MM-yyyy,HH:mm:ss");
    this.lUpdatedEpoch = this.params.data.lUpdatedEpoch;
    this.searchPowersource = [
      { id: "1", powerSource: "Grid" },
      { id: "2", powerSource: "Generator" },
      { id: "3", powerSource: "Battery" },
      { id: "4", powerSource: "Generator 2" },
      { id: "5", powerSource: "Solar" },
      { id: "6", powerSource: "Unknown" },
      { id: "22", powerSource: "Grid + Solar" },
      { id: "23", powerSource: "Generator + Solar" },
      { id: "24", powerSource: "Generator2 + Solar" },
      { id: "25", powerSource: "Battery + Solar" },
    ];
  }
  refresh(): boolean {
    return false;
  }
  constructor(
    private modalService: NgbModal,
    private http: HttpService,
    private global: Globals,
    private datePipe: DatePipe,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService
  ) {
 
  }
  onChangeName() {
    this.global.allSensorType = this.selectedCity;
    this.lineChartType = this.global.allSensorType;
  }
  generateChart() {
    let getDataJson = {};
    if (this.lUpdatedEpoch != "0") {
      getDataJson = { LastUpdated: this.lUpdatedEpoch, SiteID: this.sid };
    } else {
      getDataJson = { SiteID: this.sid };
    }
    this.http
      .post(
        this.urlAuthentication.itocUrl + this.apiUrl.powerSrcChartUrl,
        getDataJson
      )
      .subscribe(
        (res) => {
          const getResp: string = JSON.stringify(res);
          const chartDetails = JSON.parse(getResp);
          this.chartDetail = chartDetails.body.Data;
          for (var j = 0; j < this.chartDetail.length; j++) {
            const id = this.chartDetail[j].PowerSource;
            const time: string = this.chartDetail[j].Timestamp;
            const index = this.searchPowersource.findIndex(function (item) {
              return item.id == id;
            });
            if (index > -1) {
              this.powerSourceArray.push({
                id: this.searchPowersource[index].id,
                powerSource: this.searchPowersource[index].powerSource,
                timestamp: moment(time, "HH:mm:ss"),
              });
            }
          }
          this.lineChartLabels = [];
          this.lineChartData = [];
          for (var k = 0; k < this.powerSourceArray.length; k++) {
            this.lineChartLabels.push(
              moment(this.powerSourceArray[k].timestamp)
            );
            this.generateChartData(this.powerSourceArray[k].powerSource);
          }
          this.lineChartLegend = true;
          this.lineChartColors = this.lineChartData;
        },
        (error) => {
          console.error(error);
        }
      );
  }
  generateChartData(source) {
    const colors = this.generateColors(source);
    this.lineChartData.push({
      label: source,
      data: this.generateData(source),
      borderWidth: 1,
      fill: true,
      borderColor: colors[0].borderColor,
      backgroundColor: colors[0].backgroundColor,
      pointBackgroundColor: colors[0].pointBackgroundColor,
      pointBorderColor: colors[0].pointBorderColor,
      pointHoverBackgroundColor: colors[0].pointHoverBackgroundColor,
      pointHoverBorderColor: colors[0].pointHoverBorderColor,
    });
    const result = Array.from(
      new Set(this.lineChartData.map((s) => s.label))
    ).map((label) => {
      return {
        label: label,
        data: this.lineChartData.find((s) => s.label === label).data,
        borderWidth: this.lineChartData.find((s) => s.label === label)
          .borderWidth,
        fill: this.lineChartData.find((s) => s.label === label).fill,
        backgroundColor: this.lineChartData.find((s) => s.label === label)
          .backgroundColor,
        borderColor: this.lineChartData.find((s) => s.label === label)
          .borderColor,
        pointBackgroundColor: this.lineChartData.find((s) => s.label === label)
          .pointBackgroundColor,
        pointBorderColor: this.lineChartData.find((s) => s.label === label)
          .pointBorderColor,
        pointHoverBackgroundColor: this.lineChartData.find(
          (s) => s.label === label
        ).pointHoverBackgroundColor,
        pointHoverBorderColor: this.lineChartData.find((s) => s.label === label)
          .pointHoverBorderColor,
      };
    });
    this.lineChartData = [];
    this.lineChartData = result;
    return this.lineChartData;
  }
  generateData(source) {
    let data1 = [];
    const length = this.powerSourceArray.length;
    for (var i = 0; i < length; i++) {
      if (this.powerSourceArray[i].powerSource == source) {
        data1.push("50");
      } else {
        data1.push(null);
      }
    }
    return data1;
  }
  generateColors(source) {
    let linecolors = [];
    if (source == "Grid") {
      linecolors.push({
        backgroundColor: "#81C784",
        borderColor: "#81C784",
        pointBackgroundColor: "#81C784",
        pointBorderColor: "#81C784",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#81C784",
      });
    } else if (source == "Battery") {
      linecolors.push({
        backgroundColor: "#90CAF9",
        borderColor: "#90CAF9",
        pointBackgroundColor: "#90CAF9",
        pointBorderColor: "#90CAF9",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#90CAF9",
      });
    } else if (source == "Generator") {
      linecolors.push({
        backgroundColor: "#E1BEE7",
        borderColor: "#E1BEE7",
        pointBackgroundColor: "#E1BEE7",
        pointBorderColor: "#E1BEE7",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#E1BEE7",
      });
    } else if (source == "Unknown") {
      linecolors.push({
        backgroundColor: "#E0E0E0",
        borderColor: "#E0E0E0",
        pointBackgroundColor: "#E0E0E0",
        pointBorderColor: "#E0E0E0",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#E0E0E0",
      });
    } else if (source == "Solar") {
      linecolors.push({
        backgroundColor: "#BCAAA4",
        borderColor: "#BCAAA4",
        pointBackgroundColor: "#BCAAA4",
        pointBorderColor: "#BCAAA4",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#BCAAA4",
      });
    } else if (source == "Grid + Solar") {
      linecolors.push({
        backgroundColor: "#448AFF",
        borderColor: "#448AFF",
        pointBackgroundColor: "#448AFF",
        pointBorderColor: "#448AFF",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#448AFF",
      });
    } else if (
      source == "Generator + Solar" ||
      source == "Generator2 + Solar"
    ) {
      linecolors.push({
        backgroundColor: "#7E57C2",
        borderColor: "#7E57C2",
        pointBackgroundColor: "#7E57C2",
        pointBorderColor: "#7E57C2",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#7E57C2",
      });
    } else if (source == "Battery + Solar") {
      linecolors.push({
        backgroundColor: "#4DB6AC",
        borderColor: "#4DB6AC",
        pointBackgroundColor: "#4DB6AC",
        pointBorderColor: "#4DB6AC",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#4DB6AC",
      });
    }
    return linecolors;
  }
  /**
   * To open the Search Modal
   * @param content
   */
  open(content) {
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  viewFullScreen(content) {
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title", size: "lg" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  lineChartColors: any[];
  public lineChartOptions: any = {
    tooltips: {
      enabled: false,
    },
    animation: false,
    responsive: true,
    elements: {
      line: {
        borderWidth: 2,
      },
      point: {
        radius: 0,
        hitRadius: 10,
        hoverRadius: 4,
      },
    },
    legend: {
      display: true,
      position: "top",
      labels: {
        boxWidth: 10,
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            display: false,
            fontColor: "rgba(0,0,0,1)",
            fontStyle: "bold",
            beginAtZero: true,
            maxTicksLimit: 2,
            padding: 20,
          },
          gridLines: {
            drawTicks: true,
            display: false,
          },
        },
      ],
      xAxes: [
        {
          type: "time",
          time: {
            unit: "hour",
            unitStepSize: 2,
            displayFormats: {
              second: "h:mm:ss",
            },
          },
          scaleLabel: {
            display: true,
            labelString: "Time",
          },
          ticks: {
            padding: 20,
            fontColor: "rgba(0,0,0,0.5)",
            fontStyle: "bold",
            beginAtZero: true,
          },
        },
      ],
    },
  };
}
